const allYearButtons = document.querySelectorAll('.year__btn');
let currentYear = null;
const table = document.getElementById('complTable');
const tableMobile = document.querySelector('.table-mob');
const yearListEl = document.querySelector('.year-list');
const yearListMobileEl = document.querySelector('.year-list-mobile');

if (table) {
  initializeTable();
  setupYearButtons(yearListEl?.querySelectorAll('.year__btn'));
  setupYearButtons(yearListMobileEl?.querySelectorAll('.year__btn'));
}

function updateColumns(year) {
  const headers = document.querySelectorAll('thead th');
  headers?.forEach((th, index) => {
    if (index > 0) {
      if (th.dataset.prices !== year) {
        hideColumn(index);
      } else {
        showColumn(index);
      }
    }
  });
}

function updateMobileColumns(year) {
  const mobileHeaders = document.querySelectorAll('.table-mob__header-booking');
  mobileHeaders?.forEach((th, index) => {
    if (th.dataset.prices !== year) {
      hideMobileColumn(index);
    } else {
      showMobileColumn(index);
    }
  });
}

function handleYearButtonClick(btn) {
  const selectedYear = btn.dataset.year;

  updateColumns(selectedYear);
  updateMobileColumns(selectedYear);

  allYearButtons?.forEach((yearButton) => {
    if (yearButton.dataset.year === selectedYear) {
      yearButton.classList.add('btn--active');
    } else {
      yearButton.classList.remove('btn--active');
    }
  });

  document.querySelectorAll('.btn.btn_inline.btn_fixed-width[data-year]')?.forEach((dowloadButton) => {
    if (dowloadButton.dataset.year !== selectedYear) {
      dowloadButton.classList.add('btn--hidden');
    } else {
      dowloadButton.classList.remove('btn--hidden');
    }
  });
}

function setupYearButtons(buttons) {
  buttons?.forEach((btn) => {
    btn.addEventListener('click', () => handleYearButtonClick(btn));
  });
}

function hideColumn(index) {
  for (let row of table.rows) {
    const cell = row.cells[index];
    if (cell) {
      cell.style.display = 'none';
    }
  }
}

function showColumn(index) {
  for (let row of table.rows) {
    const cell = row.cells[index];
    if (cell) {
      cell.style.display = 'table-cell';
    }
  }
}

function hideMobileColumn(index) {
  const mobileHeaders = document.querySelectorAll('.table-mob__header-booking');
  if (mobileHeaders[index]) mobileHeaders[index].style.display = 'none';

  const bgHeaders = document.querySelectorAll('div.bg-th.text-th');
  if (bgHeaders[index]) bgHeaders[index].style.display = 'none';

  document.querySelectorAll('.table-mob__item-check')?.forEach((item) => {
    const yesElements = item.querySelectorAll('.yes');
    if (yesElements[index]) yesElements[index].style.display = 'none';
  });
}

function showMobileColumn(index) {
  const mobileHeaders = document.querySelectorAll('.table-mob__header-booking');
  if (mobileHeaders[index]) mobileHeaders[index].style.display = 'block';

  const bgHeaders = document.querySelectorAll('div.bg-th.text-th');
  if (bgHeaders[index]) bgHeaders[index].style.display = 'block';

  document.querySelectorAll('.table-mob__item-check')?.forEach((item) => {
    const yesElements = item.querySelectorAll('.yes');
    if (yesElements[index]) yesElements[index].style.display = 'block';
  });
}

function initializeTable() {
  currentYear = table?.parentElement.dataset.currentYear;

  document.querySelectorAll('thead th')?.forEach((th, index) => {
    if (index > 0) {
      if (th.dataset.prices !== currentYear) {
        hideColumn(index);
      }
    }
  });

  document.querySelectorAll('.table-mob__header-booking[data-prices]')?.forEach((th, index) => {
    if (th.dataset.prices !== currentYear) {
      hideMobileColumn(index);
    }
  });

  document.querySelectorAll('.year__btn')?.forEach((button) => {
    if (button.dataset.year === currentYear) {
      button.classList.add('btn--active');
    }
  });

  document.querySelectorAll('.btn.btn_inline.btn_fixed-width[data-year]')?.forEach((btn) => {
    const btnYear = btn.dataset.year;
    if (btnYear !== currentYear) {
      btn.classList.add('btn--hidden');
    }
  });
}
